import { useTranslation } from "react-i18next";
import { BiChevronLeft } from "react-icons/bi";
import { MdOutlineEdit, MdOutlineUploadFile } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Button from "shared/components/Button";
import Card from "shared/components/Card";
import Header from "shared/components/Header";
import { NAME_SPACES } from "shared/locales/constants";
import { SCREENS } from "utils/constants";

const MethodSelect = ({ onSelectManual, onSelectImport }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.PRICER);
  const IMPORT = t("IMPORT", { returnObjects: true });
  const navigate = useNavigate();

  return (
    <>
      <Header
        title={IMPORT.METHOD_SELECT.TITLE}
        subtitle={IMPORT.METHOD_SELECT.SUBTITLE}
        actions={[
          {
            text: IMPORT.METHOD_SELECT.BACK,
            onClick: () => navigate(SCREENS.PRIVATE.ADMIN.PRICERS.LIST.path),
            type: "primary--outlined",
            icon: <BiChevronLeft size={20} />,
          },
        ]}
      />
      <div className="grid--2 gap-24 mt-24">
        <Card type="simple">
          <div onClick={onSelectManual} className="pricers-method-select__card">
            <div className="pricers-method-select__icon pricers-method-select__icon--manual">
              <MdOutlineEdit size={32} color="#4c6ef5" />
            </div>
            <h3>{IMPORT.METHOD_SELECT.MANUAL_TITLE}</h3>
            <p className="pricers-method-select__description">
              {IMPORT.METHOD_SELECT.MANUAL_DESCRIPTION}
            </p>
            <Button type="primary--outlined" onClick={onSelectManual}>
              {IMPORT.METHOD_SELECT.MANUAL_ACTION}
            </Button>
          </div>
        </Card>
        <Card type="simple">
          <div onClick={onSelectImport} className="pricers-method-select__card">
            <div className="pricers-method-select__icon pricers-method-select__icon--import">
              <MdOutlineUploadFile size={32} color="#43a047" />
            </div>
            <h3>{IMPORT.METHOD_SELECT.IMPORT_TITLE}</h3>
            <p className="pricers-method-select__description">
              {IMPORT.METHOD_SELECT.IMPORT_DESCRIPTION}
            </p>
            <Button type="primary" onClick={onSelectImport}>
              {IMPORT.METHOD_SELECT.IMPORT_ACTION}
            </Button>
          </div>
        </Card>
      </div>
    </>
  );
};

export default MethodSelect;
